export const formatDepartmentsFilter = data =>
  data.map(({ departments, ...spread }) => ({
    ...spread,
    categories: departments ? formatDepartmentsFilter(departments) : null
  }))
